/**
 * Display formatting for the CRM File Manager, extracted from FileManagerPage
 * (where it was an inline `formatDate` prop-drilled into the viewer dialogs).
 * No money / reseller here — wall-neutral.
 */

/**
 * The file-manager's date+time display: `MM/DD/YYYY, HH:MM` in the en-US
 * locale, in the viewer's local timezone. An unparseable input yields the
 * platform's `Invalid Date` string (the prior inline behaviour — left
 * unguarded on purpose so callers see bad data rather than a silent blank).
 */
export function formatFileDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}
